var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      !_vm.buttons && !_vm.autocomplete && !_vm.iterator
        ? _c("v-select", {
            attrs: {
              items: _vm.locations,
              value: _vm.multiple ? _vm.value : _vm.value[0],
              "return-object": !_vm.idOnly,
              disabled: _vm.disabled,
              multiple: _vm.multiple,
              rules: _vm.rules,
              "item-text": "name",
              "item-value": "id",
              "prepend-inner-icon": "storefront",
              outlined: "",
              dense: "",
              label: "Location",
            },
            on: {
              input: function ($event) {
                return _vm.$emit("input", _vm.multiple ? $event : [$event])
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.buttons
        ? _c(
            "v-list",
            _vm._l(_vm.locations, function (location) {
              return _c(
                "v-list-item",
                { key: location.id },
                [
                  _c("SoliAvatarBtn", {
                    attrs: {
                      avatar: location.alt_image
                        ? `${location.alt_image}/m/80x80`
                        : "/musicologie-m-white.png",
                      title: location.name,
                      loading:
                        location.id == _vm.value.id ? _vm.loading : false,
                      trueDisabled: _vm.value?.id == location.id,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("input", location)
                      },
                    },
                  }),
                ],
                1
              )
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.autocomplete && !_vm.buttons && !_vm.iterator
        ? _c("v-autocomplete", {
            staticClass: "soli-blue-text",
            attrs: {
              value: _vm.value,
              items: _vm.locations,
              "search-input": _vm.search,
              multiple: _vm.multiple,
              loading: _vm.loading,
              disabled: _vm.disabled,
              rules: _vm.rules,
              "hide-details": "auto",
              "prepend-inner-icon": "storefront",
              "return-object": "",
              outlined: "",
              autofocus: _vm.autofocus,
              dense: "",
              "item-value": "id",
              "item-text": "name",
              "no-data-text": "No locations found",
              label: "Location",
            },
            on: {
              "update:searchInput": function ($event) {
                _vm.search = $event
              },
              "update:search-input": function ($event) {
                _vm.search = $event
              },
              input: (event) => {
                if (event?.id) _vm.$emit("input", event)
              },
              keydown: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                $event.preventDefault()
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "item",
                  fn: function (data) {
                    return [
                      _c("v-list-item-avatar", [
                        _c("img", {
                          attrs: {
                            src: data.item.alt_image
                              ? `${data.item.alt_image}/m/80x80`
                              : "/musicologie-m-white.png",
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-list-item-content",
                        {
                          staticClass: "max-w-min",
                          class: { "disabled-item": data.item.disabled },
                        },
                        [
                          _c("v-list-item-title", [
                            _vm._v(_vm._s(data.item.name)),
                          ]),
                          _vm._v(" "),
                          _c("v-list-item-subtitle", [
                            _vm._v(_vm._s(data.item.address)),
                          ]),
                          _vm._v(" "),
                          _c("v-list-item-subtitle", [
                            _vm._v(_vm._s(data.item.phone)),
                          ]),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ],
              null,
              false,
              1099744103
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.iterator && !_vm.autocomplete && !_vm.buttons
        ? _c("v-data-iterator", {
            attrs: {
              items: _vm.searchLocations,
              "disable-pagination": "",
              "hide-default-footer": "",
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "header",
                  fn: function () {
                    return [
                      _c(
                        "v-sheet",
                        {
                          staticStyle: {
                            position: "sticky",
                            top: "0px",
                            "z-index": "10",
                          },
                          attrs: { light: "" },
                        },
                        [
                          _c("SoliText", {
                            staticClass: "pa-3",
                            attrs: {
                              loading: _vm.loading,
                              autofocus: _vm.autofocus,
                              fullRound: "",
                              label: "Search Locations",
                              icon: "storefront",
                              hideDetails: "",
                            },
                            on: {
                              keydown: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                )
                                  return null
                                _vm.searchLocations[0].id
                                  ? _vm.$emit("input", _vm.searchLocations[0])
                                  : null
                              },
                            },
                            model: {
                              value: _vm.search,
                              callback: function ($$v) {
                                _vm.search = $$v
                              },
                              expression: "search",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "default",
                  fn: function ({ items }) {
                    return [
                      _c(
                        "v-list",
                        {
                          staticClass:
                            "soli-round divide-y py-0 overflow-auto mx-3",
                          attrs: { dense: "" },
                        },
                        _vm._l(items, function (item, idx) {
                          return _c(
                            "v-list-item",
                            {
                              key: idx,
                              staticClass: "location-list-item",
                              class: {
                                "soli-grey": _vm.value.id !== item.id,
                              },
                              attrs: { "input-value": !idx, color: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.$emit("input", item)
                                },
                              },
                            },
                            [
                              _c(
                                "v-list-item-avatar",
                                { attrs: { size: "56" } },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: item.alt_image
                                        ? `${item.alt_image}/m/80x80`
                                        : "/musicologie-m-white.png",
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-item-content",
                                { class: { "soli-grey": !!idx } },
                                [
                                  _c(
                                    "v-list-item-title",
                                    { staticClass: "font-weight-bold" },
                                    [_vm._v(_vm._s(item.name))]
                                  ),
                                  _vm._v(" "),
                                  _c("v-list-item-subtitle", [
                                    _vm._v(_vm._s(item.phone)),
                                  ]),
                                  _vm._v(" "),
                                  _c("v-list-item-subtitle", [
                                    _vm._v(_vm._s(item.address)),
                                  ]),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-item-action",
                                [
                                  _vm.value.id === item.id
                                    ? _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            small: "",
                                            color: "primary",
                                          },
                                        },
                                        [_vm._v("my_location")]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                    ]
                  },
                },
              ],
              null,
              false,
              2680092404
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }